import { render } from "./DashHeader.vue?vue&type=template&id=3444ea30&scoped=true"
import script from "./DashHeader.vue?vue&type=script&lang=js"
export * from "./DashHeader.vue?vue&type=script&lang=js"

import "./DashHeader.vue?vue&type=style&index=0&id=3444ea30&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3444ea30"]])

export default __exports__